<template>
  <div class="animated fadeIn">
    <b-row class="mt-2">
      <b-col cols="12" md="12">
        <component-header
          title="View FAQ"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Faqs' })"
        />
      </b-col>
      <b-col cols="12" md="12" class="custome-card">
        <b-card>
          <b-row v-if="$userRole === 'Tenant'" class="form-row">
            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
              <b-form-group label="Scope" label-for="Scope" :label-cols-sm="3" :label-cols="12">
                <b-form-input
                  type="text"
                  id="scope"
                  placeholder="Scope"
                  v-model="faqData.scope"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
              <b-form-group
                label="Category"
                label-for="Category"
                :label-cols-sm="3"
                :label-cols="12"
              >
                <b-form-input
                  type="text"
                  id="category"
                  v-model="faqData.category"
                  placeholder="Category"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="form-row">
            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
              <b-form-group label="Topic" label-for="Topic" :label-cols-sm="3" :label-cols="12">
                <b-form-input
                  type="text"
                  id="topic"
                  placeholder="Topic"
                  v-model="faqData.Topic"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
              <b-form-group
                label="Description"
                label-for="Description"
                :label-cols-sm="3"
                :label-cols="12"
              >
                <b-form-input
                  type="text"
                  id="description"
                  placeholder="Description"
                  v-model="faqData.Description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="form-row">
            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
              <b-form-group
                label="MediaType"
                label-for="MediaType"
                :label-cols-sm="3"
                :label-cols="12"
              >
                <b-form-input
                  type="text"
                  id="mediatype"
                  placeholder="MediaType"
                  v-model="faqData.mediaType"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="form-row">
              <b-col cols="12" sm="4" class="mb-3 mb-sm-0">
                <b-form-group
                  class="mt-3"
                  label="Media Content"
                  label-for="SmallImage"
                  :label-cols-sm="12"
                  :label-cols="12"
                ></b-form-group>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-center mb-3 mb-sm-0">
                <eb-button
                  class="download-content-btn"
                  classic="btn-primary"
                  text="Download Content"
                  @click="downloadFile"
                ></eb-button>
              </b-col>
            </b-row> 
            <b-row class="mt-2 ml-1 media-preview-row">
              <b-col cols="12" sm="12" md="6">
                  <img
                    v-if="faqData.mediaType === 'IMAGE'"
                    :src="faqData.mediaContent"
                    class="faq-view-image"
                  />
                  <video
                  v-if="faqData.mediaType === 'VIDEO'"
                  :src="faqData.mediaContent"
                  class="faq-view-video"
                  controls
                ></video>
              </b-col>
            </b-row>  
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
import currentUser from "@/mixins/currentUser";

export default {
  name: "Viewfaq",
  mixins: [currentUser],
  components: {
    ebButton,
    ComponentHeader,
  },
  data: () => {
    return {};
  },
  // props: {
  //   faqData: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    ...mapState({
      faqData: (state) => state.faq.faqData,
    }),
  },
  methods: {
    downloadFile() {
      window.open(this.faqData.mediaContent);
    },
  },
};
</script>
<style scoped>
.form-row {
    margin-bottom: 1rem;
}

.download-content-btn {
    margin-left: 0;
    width: auto;
    max-width: 180px;
}

.media-preview-row {
    margin-top: 1rem;
}

.faq-view-image {
    height: 200px;
    width: 450px;
    max-width: 100%;
    object-fit: contain;
}

.faq-view-video {
    max-width: 100%;
    max-height: 300px;
}

.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}

@media (max-width: 767.98px) {
    .download-content-btn {
        width: auto;
        max-width: 180px;
        margin-left: 0;
    }

    .faq-view-image {
        height: auto;
        width: 100%;
    }

    .faq-view-video {
        max-height: 250px;
    }

    .media-preview-row {
        margin-left: 0 !important;
    }
}
</style>
